import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';
import { completeOnboarding } from '../../services/onboardingService';
import TypewriterText from '../../components/TypewriterText';

const OnboardingStep14 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const progress = 100;

  const handleComplete = async () => {
    setLoading(true);
    setError('');

    try {
      // Mark onboarding as complete
      await completeOnboarding();

      // Navigate to main app - OnboardingGuard will handle redirects
      navigate('/');
    } catch (err) {
      console.error('Error completing onboarding:', err);
      setError(err instanceof Error ? err.message : t('onboarding.step14.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <OnboardingLayout progress={progress} showBackButton={false}>
      <div className="bg-white border-4 border-[#077f5d] p-8" style={{ boxShadow: '6px 6px 0 #077f5d' }}>

        <div className="text-center mb-8">
          <h2 className="text-base text-center text-[#077f5d] mb-4 uppercase" style={{ fontFamily: "'Press Start 2P', monospace" }}>
            {t('onboarding.step14.title')}
          </h2>
          <div className="space-y-3 mb-6">
            <TypewriterText
              texts={t('onboarding.step14.texts', { returnObjects: true }) as string[]}
              speed={35}
              delayBetween={700}
              showCursor={true}
              className="text-[#1a1a1a] font-mono text-center"
              onFinish={() => console.log('Typing done')}
              startOnView={false}
            />
          </div>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl mb-4 text-sm">
            {error}
          </div>
        )}
        <button
          type="button"
          onClick={handleComplete}
          className="w-full bg-[#3cbe8c] text-white px-8 py-4 border-2 border-[#077f5d] font-bold uppercase pointer-events-auto"
          style={{
            fontFamily: "'Press Start 2P', monospace",
            fontSize: '12px',
            boxShadow: '6px 6px 0 #077f5d',
            transition: 'none'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(-2px, -2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '6px 6px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(0, 0)';
          }}
        >
          {loading ? t('onboarding.step14.saving') : t('onboarding.step14.start')}
        </button>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingStep14;
